import { render, staticRenderFns } from "./DeskTimeSlots.vue?vue&type=template&id=5c88b1ce&scoped=true&"
import script from "./DeskTimeSlots.vue?vue&type=script&lang=js&"
export * from "./DeskTimeSlots.vue?vue&type=script&lang=js&"
import style0 from "./DeskTimeSlots.vue?vue&type=style&index=0&id=5c88b1ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c88b1ce",
  null
  
)

export default component.exports